module.exports = __webpack_public_path__ + "static/media/S2N3-5.6698fafe.svg";